module.exports = __webpack_public_path__ + "img/vietnam.cc2e55f0.svg";